<template>
  <CSidebar 
  class="fiz"
    fixed 
    :minimize="minimize"
    :show="show"
    @update:show="(value) => $store.commit('set', ['sidebarShow', value])"
  >
    <CSidebarBrand class="d-md-down-none" to="/">
      <CIcon 
        class="c-sidebar-brand-full fix1 text-center" 
        name="logo" 
        size="custom-size"         
        :width="255" 
        viewBox="0 0 456 134"
        fill= "#fff"
      />
      <CIcon 
        class="c-sidebar-brand-minimized" 
        name="logo" 
        size="custom-size" 
        :height="55" 
        viewBox="0 0 210 334"  
        fill= "#000"      
      />
    </CSidebarBrand>

    <CRenderFunction class="fix" flat :content-to-render="$options.nav"/>
    <CSidebarMinimizer
      class="d-md-down-none"
      @click.native="$store.commit('set', ['sidebarMinimize', !minimize])"
    />
  </CSidebar>
</template>

<script>
import nav from './_nav'

export default {
  name: 'TheSidebar',
  nav,
  computed: {
    show () {
      return this.$store.state.sidebarShow 
    },
    minimize () {
      return this.$store.state.sidebarMinimize 
    }
  }
}
</script>

<style scoped>

.fix {
  padding-left: 0rem;
  margin-top: 1.5rem;
}

.fix1 {
  margin-left: -22px;
  margin-top: 2.3rem;
  margin-bottom: 0,8rem;
}
.fiz {
  background: #022797;
  /* -image: linear-gradient( 135deg, #2d1cc4 10%, #2d1cc4 100%); */
}
.c-sidebar .c-sidebar-minimizer {
    background-color: rgba(248, 248, 255, 0.0);
}
.c-sidebar .c-sidebar-brand {
    color: #fff;
    background: rgba(0, 0, 21, 0);
}
.c-sidebar.c-sidebar-minimized .c-sidebar-nav-item > .c-sidebar-nav-link, .c-sidebar.c-sidebar-minimized .c-sidebar-nav-item:hover > .c-sidebar-nav-dropdown-toggle {
    background: #2d1cc4;
}
</style>
